var map = {
	"./balloons.svg": "ebe7",
	"./clock.svg": "755b",
	"./days.svg": "247b",
	"./exclusive.svg": "dcec",
	"./games.svg": "8572",
	"./handshake.svg": "9769",
	"./laptop.svg": "cd06",
	"./network.svg": "b7c3",
	"./plans.svg": "c076",
	"./quotes.svg": "35ba",
	"./schedule.svg": "6b6f",
	"./stats.svg": "5c7e",
	"./table.svg": "979b",
	"./tent.svg": "2465",
	"./whiteboard.svg": "8865"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "6f32";